import { Component, Vue } from 'vue-property-decorator'

@Component
export default class VictoryBranch extends Vue {
  protected get isVictoryBranch() {
    return Vue.prototype.$cookies.get('dataGdls').academyCode === 'CAI'
  }
}
